import { formatTranslation, inspectionStatusLabelKey } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import { InspectionStatus } from 'shared/domain/inspection/inspectionModel';
import { createEntityFilterInput } from '../common';

export const StatusFilterInput = createEntityFilterInput({
  useData: (): InspectionStatus[] => Object.values(InspectionStatus),
  transformData: (statuses, intl) =>
    statuses.map((status) => ({
      _id: status,
      label: formatTranslation(intl, inspectionStatusLabelKey(status)),
    })),
  labelId: InspectionTranslationKeys.columnLabelStatus,
  id: 'status-filter',
});
